import StoreModuleMixin from '@/mixins/StoreModuleMixin';

import { Component, Mixins } from 'vue-property-decorator';

@Component({})
export default class EmailSignUpModule extends Mixins(StoreModuleMixin) {
  mounted() {
  }
}
